import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  FUNDING_RETURN_TYPE_OPTIONS,
  FundingReturnType,
} from '@/pages/instruments/new-instrument/constants/return-types'

export interface FundingReturnTypeFieldProps {}

export const FundingReturnTypeField: React.FC<FundingReturnTypeFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ funding_return_type: FundingReturnType }>()

  return (
    <FormField
      name="funding_return_type"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Funding Return Type</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value}
              setValue={(value) =>
                setValue('funding_return_type', value as FundingReturnType, {
                  shouldValidate: true,
                })
              }
              placeholder={'Select a return type...'}
              options={FUNDING_RETURN_TYPE_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
